import { ApolloError } from '@apollo/client';

import { PointExpirationScheduleFragment } from '@occc/graphql';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { IPaginationProps } from '@occc-app/design-system';

import { PointExpirationScheduleTable } from './components';

type PointExpirationSchedulePageProps = {
  pointExpirations?: PointExpirationScheduleFragment[] | null;
  paginationProps?: IPaginationProps;
  loading?: boolean;
  error?: ApolloError;
};

export const PointExpirationSchedulePage = (props: PointExpirationSchedulePageProps) => {
  const { pointExpirations, paginationProps, loading, error } = props;

  return (
    <PointExpirationScheduleTable
      pointExpirations={pointExpirations}
      paginationProps={paginationProps}
      loading={loading}
      error={error}
    />
  );
};
